import { z } from "zod";
import type { BlockPro } from "./BlockPro";
import type { ApiResource, CreateResource } from "./resource";

export interface CreatePaymentPayload extends ApiResource {
  application_id: number;
  block_pro_data?: CreateResource<BlockPro>;
  is_favorite_pro?: boolean;
}

export const paymentStatusSchema = z.enum(["AVAILABLE", "ERROR", "FAILED", "PENDING_TRANSFER", "SUBMITTED"]);
/**
 * Payment status
 * Allowed values are:
 * - AVAILABLE: Payment is available to Pro
 * - SUBMITTED: business has submitted payment
 * - PENDING_TRANSFER: submitted the payment, but transfer is pending
 * - ERROR: Payment failed due to an issue with the location payment method
 * - FAILED: Payment failed to process
 */
export type PaymentStatus = z.infer<typeof paymentStatusSchema>;

const processingPaymentStatuses: Array<PaymentStatus> = ["PENDING_TRANSFER", "SUBMITTED"];
export const isPaymentProcessing = (status: PaymentStatus | null | undefined): boolean =>
  !!status && processingPaymentStatuses.includes(status);

const failedPaymentStatuses: Array<PaymentStatus> = ["ERROR", "FAILED"];
export const isPaymentFailed = (status: PaymentStatus | null | undefined): boolean =>
  !!status && failedPaymentStatuses.includes(status);

const paidPaymentStatuses: Array<PaymentStatus> = ["AVAILABLE"];
export const isPaymentPaid = (status: PaymentStatus | null | undefined): boolean =>
  !!status && paidPaymentStatuses.includes(status);

export const paymentSchema = z
  .object({
    id: z.number(),
    status: paymentStatusSchema,
  })
  .transform((data) => ({
    ...data,
    isProcessing: isPaymentProcessing(data.status),
    isFailed: isPaymentFailed(data.status),
    isPaid: isPaymentPaid(data.status),
  }));
